// extracted by mini-css-extract-plugin
export var container = "_gm-1";
export var editor = "_gm-2";
export var resizable = "_gm-3";
export var wrapper = "_gm-0";